/**
 * 作为每个入口的mixin，提供检测展示新手任务以及错误展示的通用方式
 * **/
import { mapGetters, mapState } from 'vuex'
import './scss/index.scss'
import { XinFeatureRecommendation, XinFeatureScore } from '@xin/xin-ui';
import { XrxsCommonUtils, XrxsCookie } from '@xin/xin-core';


export default {
  data: {
    trackId: null,
    isFeatureEnabled: window.deployFunctionSwitch && window.deployFunctionSwitch.userCenter === '1'
  },
  components: {
    XinFeatureRecommendation,
    XinFeatureScore,
  },
  created() {
    this.trackId = XrxsCookie.getCookie('XRXSTrackId');
    const uuid = XrxsCommonUtils.generatorUUID();
    if (!this.trackId) {
      XrxsCookie.setCookie('XRXSTrackId', uuid, new Date(1914506331000), '/', '.xinrenxinshi.com');
      this.trackId = uuid;
    }
  },
  computed: {
    ...mapGetters('moduleInfra', {
      'companyId': 'getCompanyId',
      'accId': 'getAccId',
      'headId': 'getHeadId',
      'company': 'getCompany',
    }),
  },
  methods: {
    changeActive($event) {
      $event.currentTarget.className = 'fixed-icon right-sidebar-container';
    },
    removeActive($event) {
      // 这一大坨是要解决抖动问题
      const offsetXArr = [-33, -32, -31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41]
      const noJitter = offsetXArr.find((item) => {
        return $event.offsetX == item
      });
      noJitter ? null : $event.currentTarget.className = 'right-sidebar-container'
    },
  }
}
